export const MIN_LENGTH = 0;
export const MAX_LENGTH = 255;
export const MIN_NUMBER = 0;
export const MAX_NUMBER = 100;
export const DEFAULT_STEP = 1;
